import { render } from "./GameWin.vue?vue&type=template&id=306940f4&scoped=true"
import script from "./GameWin.vue?vue&type=script&lang=js"
export * from "./GameWin.vue?vue&type=script&lang=js"

import "./GameWin.vue?vue&type=style&index=0&id=306940f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306940f4"]])

export default __exports__